// eslint-disable-next-line no-restricted-imports
import type {
  AccessLevel,
  MemberModel,
  MembershipModel,
} from 'app/gamma/src/types/models';

export const getMemberTypeFromMemberships = (
  memberships: Pick<
    MembershipModel,
    'idMember' | 'deactivated' | 'unconfirmed' | 'memberType'
  >[] = [],
  member: Pick<MemberModel, 'id' | 'memberType' | 'idPremOrgsAdmin'>,
  idOrganization?: string | null | undefined,
): AccessLevel => {
  const membership: typeof memberships[number] | undefined = memberships.find(
    ({ idMember }) => idMember === member.id,
  );
  let memberType: AccessLevel;

  if (
    idOrganization &&
    member.idPremOrgsAdmin &&
    member.idPremOrgsAdmin.includes(idOrganization)
  ) {
    memberType = 'admin';
  } else if (!membership) {
    memberType = 'public';
  } else if (membership.unconfirmed) {
    memberType = 'unconfirmed';
  } else if (membership.deactivated) {
    memberType = 'deactivated';
  } else {
    memberType = membership.memberType;
  }

  if (memberType !== 'public' && member.memberType === 'ghost') {
    memberType = 'virtual';
  }

  return memberType;
};
